var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message[data-v-4fd60aaf]{max-width:750px;margin:0 auto 36px;display:-ms-grid;display:grid;-ms-grid-rows:200px 1fr;grid-template-rows:200px 1fr;row-gap:27px}@media screen and (min-width:641px){.message[data-v-4fd60aaf]{margin:18px auto 0;-ms-grid-columns:290px 1fr;grid-template-columns:290px 1fr;-ms-grid-rows:auto;grid-template-rows:auto;column-gap:42px}}.message__pic[data-v-4fd60aaf]{background-image:url(" + escape(require("./images/success.png")) + ");background-size:58%;background-repeat:no-repeat;background-position:46%}@media screen and (min-width:641px){.message__pic[data-v-4fd60aaf]{background-size:65%}}.message__block[data-v-4fd60aaf]{padding:0}@media screen and (min-width:641px){.message__block[data-v-4fd60aaf]{padding:52px 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fd60aaf","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/newprogram/components/message/Message.vue
// module id = 9021e180f5a8f16251a0
// module chunks = 10